import React from 'react';
import PropTypes from 'prop-types';
import { TableCell, TableRow, Checkbox } from '@mui/material';
import { IconButton, TextField, Autocomplete } from '@totalsoft/rocket-ui';
import CancelIcon from '@mui/icons-material/Cancel';
import { onCheckBoxChange } from 'utils/propertyChangeAdapters';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';
import PhoneNumberField from 'components/common/inputs/PhoneNumberTextField';
import { consts } from 'constants/contactModeTypes';

export const ContactModeRowComponent = ({
  idx,
  contactMode,
  validation,
  contactModeTypes,
  onPropertyChange,
  deleteContactMode,
  rights
}) => {
  const disabled = rights.readOnlyFull || !rights.clientContactmodeWrite;

  return (
    <TableRow>
      <TableCell colSpan={4} style={{ paddingRight: '70px' }}>
        <Autocomplete
          id={'contactMode_contactMode_' + idx}
          fullWidth
          value={contactMode.contactModeId}
          labelKey='dictionaryItemName'
          valueKey='dictionaryItemId'
          simpleValue
          onChange={onPropertyChange('contactModeId')}
          options={contactModeTypes}
          disabled={disabled}
          error={!isValid(validation.contactModeId)}
          helperText={getErrors(validation.contactModeId)}
        />
      </TableCell>
      <TableCell colSpan={4} style={{ paddingRight: '0px' }}>
        {contactMode.contactModeId === consts.Email && (
          <TextField
            id={'contactMode_contactInfo_' + idx}
            name={'contactInfo'}
            fullWidth
            value={contactMode.contactInfo || ''}
            onChange={onPropertyChange('contactInfo')}
            disabled={disabled}
            error={!isValid(validation.contactInfo)}
            helperText={getErrors(validation.contactInfo)}
          />
        )}
        {(contactMode.contactModeId === consts.Mobile || contactMode.contactModeId === consts.Phone) && (
          <PhoneNumberField
            id={'contactMode_contactInfo_' + idx}
            country={contactMode.phoneCountryCode}
            name={'contactInfo'}
            fullWidth
            value={contactMode.contactInfo || ''}
            onChange={onPropertyChange('contactInfo')}
            disabled={disabled}
            error={!isValid(validation.contactInfo)}
            helperText={getErrors(validation.contactInfo)}
          />
        )}
      </TableCell>
      <TableCell colSpan={2} style={{ paddingRight: '0px', textAlign: 'center' }}>
        <Checkbox
          id={'contactMode_smsNotification_' + idx}
          checked={Boolean(contactMode.smsNotification)}
          onChange={onCheckBoxChange(onPropertyChange('smsNotification'))}
          color='primary'
          name='external'
          disabled={disabled}
        />
      </TableCell>
      <TableCell colSpan={2} style={{ paddingRight: '0px', textAlign: 'center' }}>
        <Checkbox
          id={'contactMode_isDefault_' + idx}
          checked={Boolean(contactMode.isDefault)}
          onChange={onCheckBoxChange(onPropertyChange('isDefault'))}
          color='primary'
          name='isDefault'
          disabled={disabled}
        />
      </TableCell>
      <TableCell style={{ textAlign: 'right' }}>
        <IconButton
          id='contactMode_deleteBtn'
          colSpan={1}
          color='primary'
          variant='text'
          size='small'
          onClick={() => deleteContactMode(contactMode)}
          disabled={disabled}
        >
          <CancelIcon />
        </IconButton>
      </TableCell>
    </TableRow>
  );
};

ContactModeRowComponent.propTypes = {
  idx: PropTypes.number,
  contactMode: PropTypes.object.isRequired,
  validation: PropTypes.object.isRequired,
  contactModeTypes: PropTypes.array.isRequired,
  onPropertyChange: PropTypes.func.isRequired,
  deleteContactMode: PropTypes.func.isRequired,
  rights: PropTypes.object.isRequired
};
export default ContactModeRowComponent;
